import React, { useCallback, useEffect, useState } from "react"
import Card from "../Card/Card"
import InputField from "../InputField/InputField"
import { faMagnifyingGlass, faMessage, faPlus, faRefresh } from "@fortawesome/free-solid-svg-icons"
import { ButtonIcon } from "../Button/Button"
import GetSpace from "../../utils/space"
import { CountElements } from "../CountElements/CountElements"
import { MessageList } from "../MessageList/MessageList"
import { customerMemory } from "../../Objects/Memory/Memory"
import { CustomerPopup } from "../../pages/Fluxo/Customer/CustomerPopup"
import { CustomerEntity } from "../../Objects/Customer/CustomerEntity"
import { PersonEntity } from "../../Objects/Person/PersonEntity"
import { TitleChildrenPath } from "../Titles/Titles"
import { SIZE } from "../../configuration/Sizes"
import THEME from "../../configuration/Theme"
import { useTranslation } from "react-i18next"

interface ListAddCustomersProps {
  handleRefreshButton?: () => void
  handleOnClick: (id: number) => void
  includeDefaultCustomer?: boolean
}

export const ListAddCustomers: React.FC<ListAddCustomersProps> = ({
  handleOnClick,
  handleRefreshButton,
  includeDefaultCustomer = true,
}) => {
  const { t } = useTranslation("customer")

  const getAvailableCards = useCallback(
    () =>
      customerMemory
        .getListCards(true)
        .filter((card) => includeDefaultCustomer || !customerMemory.findById(card.id)?.isDefaultCustomer),
    [includeDefaultCustomer],
  )

  const [dataList, setDataList] = useState(getAvailableCards)

  const [nameFind, setNameFind] = useState("")

  const [enableCostumers, SetEnableCostumers] = useState(false)

  useEffect(() => {
    setNameFind("")

    setDataList(getAvailableCards())
  }, [customerMemory.listData, getAvailableCards])

  const handleFilterName = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDataList(
      getAvailableCards().filter((ss) => {
        return (
          ss.title.toUpperCase().includes(event.target.value.toUpperCase()) ||
          (ss.dataFilter &&
            ss.dataFilter.some((filter) => filter.toUpperCase().includes(event.target.value.toUpperCase())))
        )
      }),
    )

    setNameFind(event.target.value)
  }

  return (
    <>
      <TitleChildrenPath
        children={
          <>
            <GetSpace top={5} />

            <div className="flex w-full flex-nowrap items-center gap-2">
              <div className="min-w-0 flex-1">
                <InputField
                  type={"number"}
                  maxLength={11}
                  icon={faMagnifyingGlass}
                  value={nameFind}
                  placeholder={t("label_find_place_holder")}
                  onInvalidMessage={t("label_find_onInvalidMessage")}
                  onChange={(e) => handleFilterName(e)}
                  descriptionKey="interactionDescriptions:components.listAddCostumers.listAddCustomers.input.findPlaceHolder"
                />
              </div>

              {nameFind.length === 11 && dataList.length === 0 && (
                <div className="shrink-0">
                  <ButtonIcon
                    typeButton="button"
                    type="primary"
                    size="medium"
                    icon={faPlus}
                    sizeNumber={SIZE.buttonCloseIconSize}
                    bgColor={THEME.colors.buttonBGPlusColor}
                    iconColor={THEME.colors.buttonFGPlusColor}
                    onClick={() => SetEnableCostumers(true)}
                    descriptionKey="interactionDescriptions:components.listAddCostumers.listAddCustomers.button.setEnableCostumersTrue"
                  />
                </div>
              )}

              {nameFind.length !== 11 && (
                <div className="shrink-0">
                  <ButtonIcon
                    typeButton="button"
                    type="primary"
                    size="medium"
                    icon={faRefresh}
                    sizeNumber={SIZE.buttonCloseIconSize}
                    bgColor={THEME.colors.buttonBGRegisterColor}
                    iconColor={THEME.colors.buttonFGRegisterColor}
                    onClick={handleRefreshButton}
                    descriptionKey="interactionDescriptions:components.listAddCostumers.listAddCustomers.button.handleRefreshButton"
                  />
                </div>
              )}
            </div>

            <GetSpace top={5} />

            <CountElements count={dataList.length} title={t("list:label_customer_page_message_count")} />

            <GetSpace top={5} />

            {dataList.length === 0 && (
              <>
                <MessageList message={t("list:label_customer_page_message_empty")} icon={faMessage} />

                <GetSpace top={5} />
              </>
            )}

            <div className="grid w-full items-start justify-center gap-[5px] overflow-y-auto [grid-template-columns:repeat(auto-fill,minmax(350px,1fr))]">
              {dataList.map((item) => (
                <Card
                  key={item.id}
                  keyData={item.id}
                  isDisable={item.isDisable}
                  children={item.children}
                  linkImage={item.linkImage}
                  onClick={() => handleOnClick(item.id)}
                  descriptionKey="interactionDescriptions:components.listAddCostumers.listAddCustomers.card.selectCustomer"
                />
              ))}
            </div>

            {enableCostumers && (
              <CustomerPopup
                costumer={new CustomerEntity({ personEntity: new PersonEntity({ cpf: nameFind }) })}
                title={t("title_customer_create")}
                showAll={false}
                onClonse={() => SetEnableCostumers(false)}
              />
            )}
          </>
        }
      />
    </>
  )
}
